<template>
  <div :style="styles.base">
    <div
      :class="getCss('fill-container')" :style="animateStyle" ref="mainContainer">
      <template v-for=" (item, index) in statusList">
        <div :key="index" :class="getCss('content-slot')"
             :style="{width:styles.base.width,height:styles.base.height}"
             v-show="item.value === nowStatus"
        >
          <slot :name="`${index}`">
          </slot>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
import 'animate.css';
// 空状态标志
const EMPTY_STATUS = Symbol('empty status');
export default {
  name: 'CDynamicContainer',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'dynamic-container-',
      tempStatus: '',
      inTempStatus: false,
      inAnimation: false,
      eventUid: '',
      mounted: false,
      statusFlowidArr: [],
      statusTimeArr: [],
      statusAcctypeArr: [],
      statusPlatformArr: [],
      statusAppArr: [],
      statusArr: [],
      statusFlowIDListArr: [],
      statusIsGameArr: [],
      statusIsUserAgentArr: [],
      statusIsUrlParamArr: [],
    };
  },
  computed: {
    statusList() {
      return this.configurationData.configs.statusList || [];
    },
    // 当前页面展示的状态
    nowStatus() {
      if (this.tempStatus) {
        return this.tempStatus;
      }
      if (this.inTempStatus) {
        return this.configurationData.configs.activeStatus;
      }
      // 没拿到匹配值 展示默认
      if (this.statusArr.length > 0) {
        return this.statusArr[0];
      }
      return this.configurationData.configs.activeStatus;
    },
    nowStatusConfig() {
      const { config = {} } = this.statusList.find(item => item.value === this.nowStatus) || {};
      return config;
    },
    baseExtendStyle() {
      const extendStyle = {};
      // 在动画为bounce时,父容器overflow需要设置为visible
      if (this.nowStatusConfig.style?.animate?.['animation-name'] === 'bounce' || this.inAnimation) {
        extendStyle.overflow = 'visible';
      }
      // 没有任何一个状态匹配时,组件隐藏
      if (this.nowStatus === EMPTY_STATUS) {
        extendStyle.display = 'none';
      }
      return extendStyle;
    },
    nowTimeStr() {
      return new Date().getTime();
    },
    animateStyle() {
      return this?.nowStatusConfig?.style?.animate ?? {};
    },
    isApp() {
      if (this.$ast.isAPP()) {
        return '1';
      }
      return '0';
    },
    isGame() {
      if (common.platform.isGame) {
        return '1';
      }
      return '0';
    },
  },
  mounted() {
    this.mounted = true;
    this.initialize();
  },
  methods: {
    initialize() {
      this.statusArr = [];
      // 是否需要时间判断  拿到匹配数组
      if (this.configurationData.needTime) {
        this.timeLimitStatus();
      }
      // 是否需要UserAgent  拿到匹配数组
      if (this.configurationData.needUserAgent) {
        this.userAgentLimitStatus();
        if (this.statusArr.length > 0 && this.statusIsUserAgentArr.length > 0) {
          this.statusArr = this.getArrEqual(this.statusArr, this.statusIsUserAgentArr);
        } else {
          if (this.statusIsUserAgentArr.length > 0) {
            this.statusArr = this.statusIsUserAgentArr;
          }
        }
      }
      // 是否需要url参数判断
      if (this.configurationData.needUrlParam) {
        this.channelIdLimitStatus();
        if (this.statusArr.length > 0 && this.statusIsUrlParamArr.length > 0) {
          this.statusArr = this.getArrEqual(this.statusArr, this.statusIsUrlParamArr);
        } else {
          if (this.statusIsUrlParamArr.length > 0) {
            this.statusArr = this.statusIsUrlParamArr;
          }
        }
      }
      // 是否需要平台判断  拿到匹配数组
      if (this.configurationData.needPlatform) {
        this.platformLimitStatus();
        if (this.statusArr.length > 0 && this.statusPlatformArr.length > 0) {
          this.statusArr = this.getArrEqual(this.statusArr, this.statusPlatformArr);
        } else {
          if (this.statusPlatformArr.length > 0) {
            this.statusArr = this.statusPlatformArr;
          }
        }
      }
      // 是否需要端内外判断  拿到匹配数组
      if (this.configurationData.needApp) {
        this.appLimitStatus();
        if (this.statusArr.length > 0 && this.statusAppArr.length > 0) {
          this.statusArr = this.getArrEqual(this.statusArr, this.statusAppArr);
        } else {
          if (this.statusAppArr.length > 0) {
            this.statusArr = this.statusAppArr;
          }
        }
      }
      if (this.configurationData.refreshTimeStatus === 'login') {
        const self = this;
        this.$onLogined(async () => {
          await self.refreshTime();
        });
      }
      if (this.configurationData.refreshTimeStatus === 'role') {
        const self = this;
        this.$onRoleReady(async () => {
          if (!this.configurationData.needTime
            && !this.configurationData.needUserAgent
            && !this.configurationData.needPlatform
            && !this.configurationData.needUrlParam
            && !this.configurationData.needApp) {
            this.statusArr = [];
          }
          await self.refreshTime();
        });
      }
      if (this.configurationData.refreshTimeStatus === 'qua') {
        const self = this;
        this.$onQuaRefreshed(async () => {
          if (!this.configurationData.needTime
            && !this.configurationData.needUserAgent
            && !this.configurationData.needPlatform
            // && !this.configurationData.needUrlParam
            && !this.configurationData.needApp) {
            this.statusArr = [];
          }
          await self.refreshTime();
        });
      }
      {
        const self = this;
        this.$eventBus.$on('ceiba:custom:events:refresh:container:status', async () => {
          // 动态调用刷新多状态
          await self.refreshTime();
        });
      }
    },
    setTempStatus({ status, animation }) {
      if (this.inAnimation) return;
      const currentIndex = Math.max(this.statusList.findIndex(item => item.value === this.nowStatus), 0);
      const statusLen = this.statusList.length;
      if (status === 'prev') {
        const preIndex = (statusLen + currentIndex - 1) % statusLen;
        this.tempStatus = this.statusList[preIndex].value;
      } else if (status === 'next') {
        const nextIndex = (statusLen + currentIndex + 1) % statusLen;
        this.tempStatus = this.statusList[nextIndex].value;
      } else {
        this.tempStatus = status;
      }
      this.inTempStatus = true;
      animation && this.animate(animation);
    },
    animate(animation) {
      this.animateOut(animation);
      this.$nextTick(() => {
        this.animateIn(animation);
      });
    },
    animateIn({ animationName, animationDuration }) {
      const inEl = this.$el.firstElementChild.cloneNode(true);
      inEl.classList.add(this.getCss('repeated-el'));
      inEl.classList.remove(this.getCss('hide'));
      inEl.setAttribute('style', `animation-name: ${animationName}; animation-duration: ${animationDuration}ms`); // 清除原有的动画
      this.$el.appendChild(inEl);
      setTimeout(() => {
        this.$el.removeChild(inEl);
      }, animationDuration);
    },
    // 移出动画固定为为淡出
    animateOut({ animationDuration }) {
      this.inAnimation = true;
      const outEl = this.$el.firstElementChild.cloneNode(true);
      this.$el.firstElementChild.classList.add(this.getCss('hide'));
      outEl.classList.add(this.getCss('repeated-el'), this.getCss('fade-out'));
      outEl.setAttribute('style', `animation-duration: ${animationDuration}ms`); // 清除原有的动画
      outEl.classList.add('rotateInDownLeft');
      this.$el.appendChild(outEl);
      setTimeout(() => {
        this.$el.removeChild(outEl);
        this.$el.firstElementChild.classList.remove(this.getCss('hide'));
        this.inAnimation = false;
      }, animationDuration);
    },
    // 刷新时间
    async refreshTime() {
      if (this.configurationData.needAcctype) {
        await this.acctypeLimitStatus();
        // 如果匹配数组已存在值  进行匹配重复值
        if (this.statusArr.length > 0 && this.statusAcctypeArr.length > 0) {
          this.statusArr = this.getArrEqual(this.statusArr, this.statusAcctypeArr);
        } else {
          if (this.statusAcctypeArr.length > 0) {
            this.statusArr = this.statusAcctypeArr;
          }
        }
      }
      if (this.configurationData.needIsGame) {
        await this.isGameLimitStatus();
        // 如果匹配数组已存在值  进行匹配重复值
        if (this.statusArr.length > 0 && this.statusIsGameArr.length > 0) {
          this.statusArr = this.getArrEqual(this.statusArr, this.statusIsGameArr);
        } else {
          if (this.statusIsGameArr.length > 0) {
            this.statusArr = this.statusIsGameArr;
          }
        }
      }
      // 是否需要根据流程判断返回  拿到匹配数组
      if (this.configurationData.needFlow) {
        await this.flowidLimitStatus();
        if (this.statusArr.length > 0 && this.statusFlowidArr.length > 0) {
          this.statusArr = this.getArrEqual(this.statusArr, this.statusFlowidArr);
        } else {
          if (this.statusFlowidArr.length > 0) {
            this.statusArr = this.statusFlowidArr;
          }
        }
      }
      // 是否需要多流程判断  拿到匹配数组
      if (this.configurationData?.needFlowIDList) {
        await this.flowIDListLimitStatus();
        if (this.statusArr.length > 0 && this.statusFlowIDListArr.length > 0) {
          this.statusArr = this.getArrEqual(this.statusArr, this.statusFlowIDListArr);
        } else {
          if (this.statusFlowIDListArr.length > 0) {
            this.statusArr = this.statusFlowIDListArr;
          }
        }
      }
    },
    // 流程返回判断   目前不支持传参获取状态
    async flowidLimitStatus() {
      this.statusFlowidArr = [];
      // 根据配置读取返回值
      const response = await this.flowRequest({
        flowId: this.configurationData.flowID,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({ gid: `${this.currentGid}`, gameCode: `${this.currentGameCode}` }),
        },
      });
      // 响应 {"ret":0,"msg":"","data":"{\"level\":7,\"ret\":0}"}
      const fieldStrObj = response.data || { ret: -1 };
      if (fieldStrObj.ret === -1) {
        return;
      }
      // 根据返回值与配置的列表进行匹配
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style.limit) {
            const { fieldStr, fieldValueStr } = item.config.style.limit;
            if (typeof fieldValueStr === undefined || typeof fieldStr === undefined) {
              return;
            }
            if (fieldValueStr.match(/^[([][0-9]+,[0-9]+[)\]]$/)) {
              const smallVal = parseInt(fieldValueStr.split(',').shift()
                .split('[')
                .pop()
                .split('(')
                .pop(), 10);
              const bigVal = parseInt(fieldValueStr.split(',').pop()
                .split(']')
                .shift()
                .split(')')
                .shift(), 10);
              if (typeof fieldStrObj[fieldStr] !== 'undefined') {
                if (fieldStr && parseInt(fieldStrObj[fieldStr], 10) >= smallVal
                  && bigVal >= parseInt(fieldStrObj[fieldStr], 10)) {
                  if (!this.isInArray(this.statusFlowidArr, item.value)) {
                    this.statusFlowidArr.push(item.value);
                  }
                }
              }
            } else {
              const fieldArr = fieldValueStr.split('|');
              if (typeof fieldStrObj[fieldStr] !== 'undefined') {
                if (fieldStr && fieldArr.length > 0 && this.isInArray(fieldArr, fieldStrObj[fieldStr])) {
                  if (!this.isInArray(this.statusFlowidArr, item.value)) {
                    this.statusFlowidArr.push(item.value);
                  }
                }
              }
            }
          }
        });
      }
    },
    // 时间判断
    timeLimitStatus() {
      if (this.$isInEditor) return;
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style.limit) {
            const startTime = item.config.style.limit.startTime.replace(/-/g, '/');
            const endTime = item.config.style.limit.endTime.replace(/-/g, '/');
            // 根据前端获取的当前时间与配置时间进行匹配
            if (startTime && endTime && parseInt(this.nowTimeStr, 10) > parseInt(this.getTime(startTime), 10)
              && parseInt(this.nowTimeStr, 10) <= parseInt(this.getTime(endTime), 10)) {
              if (!this.isInArray(this.statusArr, item.value)) {
                this.statusArr.push(item.value);
              }
            }
          }
        });
      }
    },
    // userAgentLimitStatus判断
    userAgentLimitStatus() {
      if (this.$isInEditor) return;
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style.limit) {
            const { userAgentStr } = item.config.style.limit;
            // 根据前端userAgent进行匹配
            if (userAgentStr && navigator.userAgent.indexOf(userAgentStr) > -1) {
              if (!this.isInArray(this.statusIsUserAgentArr, item.value)) {
                this.statusIsUserAgentArr.push(item.value);
              }
            }
          }
        });
      }
    },
    // channelIdLimitStatus判断
    channelIdLimitStatus() {
      if (this.$isInEditor) return;
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style.limit) {
            const { urlParamStr } = item.config.style.limit;
            // 根据url参数进行匹配,eg via=xy_1
            const [urlKey = '', urlValue = ''] = urlParamStr.split('=');
            if (urlParamStr && common.tool.getQueryparams(urlKey)?.indexOf(urlValue) > -1) {
              if (!this.isInArray(this.statusIsUrlParamArr, item.value)) {
                this.statusIsUrlParamArr.push(item.value);
              }
            }
          }
        });
      }
    },
    // 平台判断
    platformLimitStatus() {
      this.statusPlatformArr = [];
      if (this.$isInEditor) return;
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style.limit) {
            const { platform } = item.config.style.limit;
            if (platform === common.platform.device && !this.isInArray(this.statusPlatformArr, item.value)) {
              this.statusPlatformArr.push(item.value);
            }
          }
        });
      }
    },
    // 端内外判断
    appLimitStatus() {
      this.statusAppArr = [];
      if (this.$isInEditor) return;
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style.limit) {
            const isApp = item.config.style.limit.app;
            if (isApp === this.isApp && !this.isInArray(this.statusAppArr, item.value)) {
              this.statusAppArr.push(item.value);
            }
          }
        });
      }
    },
    // 登录类型判断
    acctypeLimitStatus() {
      this.statusAcctypeArr = [];
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style.limit) {
            const { acctypeStr } = item.config.style.limit;
            // 根据当前登录的acctype  与配置的进行匹配
            let acctype = this.getCookie('acctype');
            if (acctype !== 'wx') {
              acctype = 'qc';
            }
            if (acctypeStr === acctype && !this.isInArray(this.statusAcctypeArr, item.value)) {
              this.statusAcctypeArr.push(item.value);
            }
          }
        });
      }
    },
    // 游戏内外判断
    isGameLimitStatus() {
      this.isGameLimitStatus = [];
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style.limit) {
            const { isGame } = item.config.style.limit;
            if (isGame === this.isGame && !this.isInArray(this.statusIsGameArr, item.value)) {
              this.statusIsGameArr.push(item.value);
            }
          }
        });
      }
    },
    // 多流程判断
    async flowIDListLimitStatus() {
      this.statusFlowIDListArr = [];
      if (this.configurationData?.flowIDConfigList) {
        // 根据配置读取返回值列表
        const that = this;
        const flowIDConfigList = this.configurationData?.flowIDConfigList;
        let flowIdArr = [];
        const resAllArr = [];
        // 获取流程id数组
        flowIDConfigList.forEach((item) => {
          flowIdArr = [...flowIdArr, ...item.flowIDList];
        });
        // 去重
        flowIdArr = this.unique(flowIdArr);
        const promiseList = flowIdArr.map(flow => that.flowRequest({
          flowId: flow,
          params: {
            role: this.roleInfo,
          },
        }));
        const resAll = (await Promise.allSettled(promiseList))
          .filter(request => request.status === 'fulfilled')
          .map(request => request.value);
        if (flowIdArr.length !== resAll.length) {
          return;
        }
        for (let i = 0; i <= resAll.length - 1; i++) {
          resAllArr[flowIdArr[i]] = resAll[i];
        }

        // 根据配置去匹配对应的状态
        flowIDConfigList.forEach((item) => {
          let flowIDListStatus = true;
          for (let i = 0; i <= item.length - 1; i++) {
            resAllArr[flowIdArr[i]] = resAll[i];
          }
          if (!item.flowIDList.length && !Array.isArray(item.flowIDList)) {
            flowIDListStatus = false;
          } else {
            item.flowIDList.forEach((flowId) => {
              if (resAllArr[flowId].ret !== 0 || resAllArr[flowId].data.ret !== 0) {
                flowIDListStatus = false;
              }
            });
          }
          if (flowIDListStatus) {
            if (!this.isInArray(this.statusFlowIDListArr, item.statusId)) {
              this.statusFlowIDListArr.push(item.statusId);
            }
          }
        });
      }
    },
    getTime(str) {
      return new Date(str).getTime();
    },
    unique(arr) {
      const newArr = [];
      for (let i = 0; i < arr.length; i++) {
        if (newArr.indexOf(arr[i]) === -1) {
          newArr.push(arr[i]);
        }
      }
      return newArr;
    },
    getArrEqual(arr1, arr2) {
      const newArr = [];
      for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
          if (arr1[j] === arr2[i]) {
            newArr.push(arr1[j]);
          }
        }
      }
      return newArr;
    },
    isInArray(arr, val) {
      let status = false;
      for (let i = 0; i < arr.length; i++) {
        if (val.toString() === arr[i].toString()) {
          status = true;
        }
      }
      return status;
    },
    getCookie(key) {
      const reg = new RegExp(`(^| )${key}=([^;]*)(;|$)`);
      const arr = document.cookie.match(reg);
      if (arr) {
        return arr[2];
      }
      return null;
    },
    doTaskAction() {
      const nodeList = this.$refs.mainContainer.querySelectorAll('.csu-dynamic-container-content-slot') || [];
      for (let i = 0; i < nodeList.length; i++) {
        const node = nodeList[i];
        if (node && node.style.display !== 'none') {
          if (node.childNodes && node.childNodes.length > 0) {
            // 找到第一个按钮点击
            for (let k = 0; k < node.childNodes.length; k++) {
              if (node.childNodes[k]?.nodeName === 'BUTTON') {
                node.childNodes[k]?.click();
                return;
              }
            }
          }
          return;
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import './dynamic.scss';
</style>
